interface BaseAction<T extends { value: string; id: number; }> {
  payload: T | Partial<T>;
  type: 'add' | 'remove' | 'update';
}
interface AddAction<T extends { value: string; id: number; }> extends BaseAction<T> {
  type: 'add';
  payload: T;
}
interface RemoveAction<T extends { value: string; id: number; }> extends BaseAction<T> {
  type: 'remove';
  payload: T;
}
interface UpdateAction<T extends { value: string; id: number; }> extends BaseAction<T> {
  type: 'update';
  payload: T;
}

export type UpdateUtterancesAction<T extends { value: string; id: number; }> = AddAction<T> | RemoveAction<T> | UpdateAction<T>;

export function updateUtterances<T extends { value: string; id: number; }>(
  array: string[],
  action: UpdateUtterancesAction<T>
): string[] {
  const payload = action.payload;
  const value = payload.value;
  const id = payload.id;
  switch (action.type) {
    case 'add':
      array.push(value);
      return array;
    case 'remove':
      return array.filter((_item, index) => index !== +id);
    case 'update':
      array[id] = value;
      return array;
    default:
      return array;
  }
}
